<template>
  <div
    :class="{ 'text-xs-right': align == 'right', 'text-xs-left': align == 'left' }"
    v-if="value"
    style="position: relative; display: inline-block;"
    :style="{ 'width': fullWidth ? '100%' : undefined }"
  >
    <img
      v-if="selectedBot && showProfile && answers.length > 0 && answers[0].length > 0"
      :src="selectedBot.pagelogo || imageProfile"
      alt
      style="
          margin-left: 10px;
          width: 28px;
          height: 28px;
          border: 1px solid #eee;
          border-radius: 50%;
          float: left;
          margin-right: 5px;
        "
    />
    
    <div style="overflow-y: initial">
      <div
        v-for="(message, index) in answers[intent_index]"
        :key="'answer_message_' + index"
        style="margin-bottom: 5px"
        class="text-xs-left"
      >
        <v-tooltip v-if="status && status === 'standby' && align === 'left' && ((message.type != 'text' && message.type != 'button')||message.text == '{viewsummary}')" top>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" >
              <i class="fa fa-exclamation-triangle warning-icon" aria-hidden="true"></i>
            </span>
          </template>
          <span>{{ errorMsg }}</span>
        </v-tooltip>
        <v-tooltip v-if="status && status !== 'standby' && ((message.type != 'text' && message.type != 'button')||message.text == '{viewsummary}')" top>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" >
              <i class="fa fa-exclamation-triangle alert-icon" aria-hidden="true"></i>
            </span>
          </template>
          <span>{{ errorMsg }}</span>
        </v-tooltip>
        <template v-if="message.type == 'text' || message.type == 'button'">
          <template v-if="message.text == '{viewsummary}'">
            <view-cart-summary-viewer></view-cart-summary-viewer>
          </template>
          <template v-else>
            <div
              class="message"
              v-if="
                (message.text != '' && message.type == 'text') ||
                  (message.type == 'button' && (message.buttons.length > 0 || message.text != ''))
              "
              style="
                  word-break: break-word;
                  position: relative;
                  border-radius: 12px;
                  max-width: 200px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: initial;
                  margin-bottom: 5px;
                  white-space: initial;
                "
              :style="{ float: align }"
            >
            <v-tooltip class="" v-if="status && status === 'standby' && align === 'left'" top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" class="tooltip-error warning-icon">
                  <i class="fa fa-exclamation-triangle warning-icon" aria-hidden="true"></i>
                </span>
              </template>
              <span>{{ errorMsg }}</span>
            </v-tooltip>
            <v-tooltip class="" v-else-if="status && status !== 'standby'" top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" class="tooltip-error margin-icon">
                  <i class="fa fa-exclamation-triangle alert-icon" aria-hidden="true"></i>
                </span>
              </template>
              <span>{{ errorMsg }}</span>
            </v-tooltip>
            <div style="font-size: 12px" :style="{ color: color }">
              <div style="padding: 5px 8px 6px" :style="{ 'background-color': background }">
                  <span style="line-height: 15.36px; line-height: 22px">
                    <template v-if="message.text != ''">
                      <specialtext :text="message.text"></specialtext>
                    </template>
                    <template v-else> </template>
                  </span>
                </div>
              </div>
              <div
                v-if="message.buttons && message.buttons.length > 0"
                style="
                    width: 100%;
                    border: 1px solid #eee;
                    border-bottom-right-radius: 12px;
                    border-bottom-left-radius: 12px;
                    overflow: hidden;
                  "
                :style="{ float: align }"
              >
                <ul class="list-group list-group-flush" style="margin-bottom: 0px">
                  <li
                    class="list-group-item"
                    style="
                        border: none;
                        border-top: 1px solid #eee;
                        border-radius: 0px;
                        text-align: center;
                        padding: 2px 15px;
                      "
                    v-for="(button, bindex) in message.buttons"
                    :key="bindex"
                    :style="{
                      'border-top': bindex != 0 ? '1px solid #eee' : 'none',
                      padding: !showDeep ? '10px 0' : isBotTest ? '6px 15px' : '2px 15px'
                    }"
                  >
                    <template v-if="button">
                      <span style="color: #0084ff">
                        <template v-if="button.type == 'web_url'">
                          <a
                            v-if="isURL(button.url)"
                            :href="updateQueryString(button.url, 'from', 'livechat')"
                            target="_blank"
                            rel="noopener noreferrer"
                            >{{ button.title | truncate(20) }}
                          </a>
                          <template v-else>
                            <div class="primary--text" v-if="!isBotTest">
                              {{ button.title | truncate(20) }}
                            </div>
                            <div
                              style="cursor: pointer"
                              class="primary--text"
                              v-else
                              @click="
                                openShopModel(
                                  button.url
                                    ? button.url.includes('{shopurl}')
                                      ? button.url.replace(
                                          '{shopurl}',
                                          `https://shopv2.zwiz.app/ecommerce/${pageid}?testbot=true`
                                        )
                                      : button.url.replace(
                                          '{salepage}',
                                          `https://shopv2.zwiz.app/salepage/${pageid}?testbot=true`
                                        )
                                    : ''
                                )
                              "
                            >
                              {{ button.title | truncate(20) }}
                            </div>
                          </template>
                        </template>
                        <template v-else>
                          <span
                            v-if="!isBotTest"
                            style="cursor: pointer"
                            v-clipboard:copy="button.title"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onCopyError"
                          >
                            {{ button.title | truncate(20) }}
                          </span>
                          <span v-else style="cursor: pointer" @click="btnClick(button)">
                            {{ button.title | truncate(20) }}
                          </span>
                        </template>
                      </span>
                      <div style="margin: 0; font-size: 10px" v-if="showDeep && !isBotTest">
                        <span v-if="button.type == 'web_url'" :title="button.url">{{
                          button.url | truncate(20)
                        }}</span>
                        <span
                          style="cursor: pointer"
                          v-clipboard:copy="button.payload"
                          v-clipboard:success="onCopy"
                          v-clipboard:error="onCopyError"
                          v-else-if="button.type == 'postback'"
                          :title="button.payload"
                          >{{ button.payload | truncate(20) }}</span
                        >

                        <span v-else-if="button.type == 'phone_number'" :title="button.payload">{{
                          button.payload | truncate(20)
                        }}</span>
                        <span v-else>&nbsp;</span>
                      </div>
                    </template>
                  </li>
                </ul>
              </div>
            </div>
          </template>
          <div class="clearfix"></div>
        </template>
        <template v-else-if="message.type == 'image'">
          <template v-if="message.image_url">
            <template v-for="(image, k) in $options.filters.splitimg(message.image_url)">
              <image-type
                :key="`image_${k}`"
                :value="image"
                :width="
                  message.image_url &&
                  message.image_url != null &&
                  $options.filters.splitimg(message.image_url).length > 1
                    ? '100px'
                    : '181px'
                "
                :align="align"
              ></image-type>
            </template>
          </template>
        </template>
        <template v-else-if="message.type == 'file'">
          <template v-if="message.file_url">
            <FileType v-model="message.file_url"></FileType>
          </template>
        </template>
        <template
          v-else-if="
            message.type == 'video' &&
              channel != 'line' &&
              $route.name == 'allinonechat' &&
              message.video_url
          "
        >
          <div
            class="message"
            style="
                position: relative;
                border-radius: 12px;
                max-width: 250px;
                overflow-wrap: break-word;
                min-height: 22px;
                min-width: 14px;
                line-height: 15.36px;
                overflow: hidden;
                margin-bottom: 5px;
                white-space: initial;
              "
            :style="{ float: align }"
          >
            <div style="font-size: 12px" :style="{ color: color }">
              <div style="padding: 5px 8px 6px" :style="{ 'background-color': background }">
                <span style="line-height: 15.36px; line-height: 22px">
                  <template v-if="message.video_url">
                    <div v-if="message.video_url">
                      <video width="100%" height="200px" controls>
                        <source :src="message.video_url" type="video/mp4" />
                      </video>
                    </div>
                  </template>
                  <template v-else-if="message.source">
                    <div v-if="message.source">
                      <video width="100%" height="200px" controls>
                        <source :src="message.source" type="video/mp4" />
                      </video>
                    </div>
                  </template>

                  <div v-else>-</div>
                </span>
              </div>
            </div>
          </div>
        </template>
        <template
          v-else-if="
            message.type == 'video' &&
              channel == 'line' &&
              $route.name == 'allinonechat' &&
              message.video_url
          "
        >
          <div
            class="message"
            style="
                position: relative;
                border-radius: 12px;
                overflow-wrap: break-word;
                min-height: 22px;
                min-width: 14px;
                line-height: 15.36px;
                overflow: hidden;
                margin-bottom: 5px;
                white-space: initial;
              "
            :style="{ float: align }"
          >
            <div style="font-size: 12px" :style="{ color: color }">
              <div style="padding: 5px 8px 6px" :style="{ 'background-color': background }">
                <span style="line-height: 15.36px; line-height: 22px">
                  <LineContentVideo v-model="message.video_url" :pageid="pageid">
                    <template v-slot="{ url }">
                      <video width="100%" height="200px" controls>
                        <source type="video/mp4" :src="url" />
                      </video>
                    </template>
                  </LineContentVideo>
                </span>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="message.type == 'audio'">
          <div
            class="message"
            style="
                position: relative;
                border-radius: 12px;
                overflow-wrap: break-word;
                min-height: 22px;
                min-width: 14px;
                line-height: 15.36px;
                overflow: hidden;
                margin-bottom: 5px;
                white-space: initial;
              "
            :style="{ float: align }"
          >
            <template v-if="message.text != ''">
              <audio controls>
                <source :src="message.audio_url" type="audio/ogg" />
                <source :src="message.audio_url" type="audio/mpeg" />
              </audio>
            </template>
            <template v-else>-</template>
          </div>
        </template>
        <template v-else-if="message.type == 'payment'">
          <div
            :style="{ float: align }"
            style="
                padding: 1em;
                text-align: left;
                position: relative;
                border-radius: 12px;
                width: 281px;
                min-height: 100px;
                overflow-wrap: break-word;
                min-height: 22px;
                min-width: 14px;
                line-height: 15.36px;
                overflow: hidden;
                background-color: #eeeeee;
              "
          >
            <v-layout style="margin-bottom: 0px" row>
              <vue-simple-svg
                :filepath="'/static/img/assets/get_started/payment.svg'"
                width="40px"
                height="40px"
                class="img"
                style="
                    border-right: 2px solid #c5c5c5;
                    padding-right: 10px;
                    padding-top: 1em;
                    padding-bottom: 1em;
                    vertical-align: middle;
                  "
              />
              <v-flex style="padding-left: 1em">
                <div style="margin-bottom: 10px">
                  <strong>{{ $t('Detail') }}:</strong>
                  <br />
                  {{ message.data.detail }}
                </div>
                <div style="margin-bottom: 10px">
                  <strong>{{ $t('Amount') }}:</strong>
                  <br />
                  {{ message.data.amount }}
                </div>
                <div style="margin-bottom: 10px">
                  <strong>{{ $t('Delivery Method') }}:</strong>
                  <br />
                  {{ message.data.delivery.name }}
                </div>
                <div style="margin-bottom: 10px">
                  <strong>{{ $t('Response Message') }}:</strong>
                  <br />
                  {{ message.data.response }}
                </div>
              </v-flex>
            </v-layout>
          </div>
        </template>
        <template v-else-if="message.type == 'pay_solutions_link'">
          <div
            :style="{ float: align }"
            style="
                padding: 1em;
                text-align: left;
                position: relative;
                border-radius: 12px;
                width: 281px;
                min-height: 100px;
                overflow-wrap: break-word;
                min-height: 22px;
                min-width: 14px;
                line-height: 15.36px;
                overflow: hidden;
                background-color: #eeeeee;
              "
          >
            <v-layout style="margin-bottom: 0px" row>
              <vue-simple-svg
                :filepath="'/static/img/assets/paysolution/account_wallet.svg'"
                width="40px"
                height="40px"
                class="img"
                style="
                    border-right: 2px solid #c5c5c5;
                    padding-right: 10px;
                    padding-top: 1em;
                    padding-bottom: 1em;
                    vertical-align: middle;
                  "
              />
              <v-flex style="padding-left: 1em">
                <div style="margin-bottom: 10px">
                  <strong>{{ $t('Detail') }}:</strong>
                  <br />
                  {{ message.data.detail }}
                </div>
                <div style="margin-bottom: 10px">
                  <strong>{{ $t('Amount') }}:</strong>
                  <br />
                  {{ message.data.value }}
                </div>
                <div style="margin-bottom: 10px">
                  <strong>{{ $t('Response Message') }}:</strong>
                  <br />
                  {{ message.data.text }}
                </div>
              </v-flex>
            </v-layout>
          </div>
        </template>
        <template v-else-if="message.type == 'meta_pay'">
          <div
            style="
                  padding: 1em;
                  float: left;
                  position: relative;
                  border-radius: 12px;
                  width: 240px;
                  min-height: 100px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                  background-color: #eeeeee;
                "
          >
            <v-layout style="margin-bottom: 0px; word-break: break-all" row>
              <vue-simple-svg
                :filepath="'/static/img/assets/get_started/payment.svg'"
                width="35px"
                height="35px"
                class="img"
                style="
                      padding-right: 10px;
                      padding-top: 1em;
                      padding-bottom: 1em;
                      vertical-align: middle;
                    "
              />
              <h4 style="color: #000; align-self: center; font-size: 16px; margin-left: 11px;">
                ฿{{ message.amount }} ส่งคำขอให้ชำระเงินแล้ว
              </h4>
            </v-layout>
            <h4
              class="text-xs-center"
              style="background: #fff; padding: 12px; border-radius: 14px; color: #000"
            >
              ชำระเงิน
            </h4>
          </div>
        </template>
        <template
          v-else-if="['removeandaddtocart', 'addtocart', 'removetocart'].includes(message.type)"
        >
          <span>
            <view-cart-summary-viewer2
              @openShopModel="openShopModel"
              :isBotTest="isBotTest"
              :items="message.data"
            ></view-cart-summary-viewer2>
          </span>
          <span></span>
        </template>
        <template v-else-if="message.type == 'generic'">
          <generic-viewer
            @openShopModel="openShopModel"
            :isBotTest="isBotTest"
            @clickBtnMessage="btnClick"
            v-model="message.data"
            :size="size"
            :align="align"
            :ratio="message.ratio"
          ></generic-viewer>
        </template>
        <template v-else-if="message.type == 'ntn_template'">
          <ntn-viewer
            @openShopModel="openShopModel"
            @clickBtnMessage="btnClick"
            :isBotTest="isBotTest"
            :ratio="message.ratio"
            :ntn_message="message.data"
            :key="'generic_'"
            :size="size"
            :align="align"
          ></ntn-viewer>
        </template>
        <template v-else-if="message.type == 'welcome_message'">
          <v-layout>
            <v-flex
              v-if="channel == 'all' && hasWCMultiChannel"
              shrink
              class="channel"
              style="border-right: 1px solid #eee"
            >
              <ChannelTab :tab="welcome_channel" @onChange="changeWelcomeChannelTab"></ChannelTab>
            </v-flex>
            <v-flex>
              <message-viewer
                v-if="welcomemessage"
                v-model="welcomemessage"
                :size="size"
                :channel="channel == 'all' ? welcome_channel : channel"
                :align="align"
                :isBotTest="isBotTest"
                @clickBtnMessage="btnClick"
              ></message-viewer>
            </v-flex>
          </v-layout>
          <template> </template>
        </template>
        <template v-else-if="message.type == 'video'">
          <div
            class="message"
            style="
                min-height: 150px;
                position: relative;
                border-radius: 12px;
                width: 265px;
                overflow-wrap: break-word;
                min-height: 22px;
                min-width: 14px;
                line-height: 15.36px;
                overflow: hidden;
              "
            :style="{ float: align }"
          >
            <template v-if="$route.name == 'allinonechat'">
              <div v-if="message.source">
                <video width="100%" controls>
                  <source :src="message.source" type="video/mp4" />
                </video>
              </div>
            </template>
            <template v-else>
              <template v-if="message.picture">
                <v-img :src="message.picture" :aspect-ratio="16 / 9" color="grey"></v-img>
              </template>
              <template v-else>
                <v-responsive :aspect-ratio="16 / 9">
                  <div style="background: #eee; height: 100%"></div>
                </v-responsive>
              </template>

              <v-layout
                fill-height
                absolute
                class="text-xs-center"
                style="top: 0; bottom: 0; position: absolute; left: 0; right: 0"
              >
                <div
                  style="margin: auto; width: 100%"
                  :title="message.source"
                  :alt="message.source"
                >
                  <v-btn fab small depressed color="white">
                    <v-icon large>play_circle_filled</v-icon>
                  </v-btn>
                </div>
              </v-layout>
            </template>
          </div>
          <div class="clearfix"></div>
        </template>
        <template v-else-if="message.type == 'responsepost'">
          <template v-if="message.replyinbox">
            <i class="fas fa-check-circle primary-color"></i>
            {{ $t('Reply to inbox') }}
            <div v-for="(inbox, iindex) in message.responseinbox" :key="'response_inbox_' + iindex">
              <template v-if="inbox.type == 'text' || inbox.type == 'button'">
                <div
                  class="message"
                  v-if="
                    (inbox.text != '' && inbox.type == 'text') ||
                      (inbox.type == 'button' && (inbox.buttons.length > 0 || inbox.text != ''))
                  "
                  style="
                      position: relative;
                      border-radius: 12px;
                      max-width: 181px;
                      overflow-wrap: break-word;
                      min-height: 22px;
                      min-width: 14px;
                      line-height: 15.36px;
                      overflow: hidden;
                      margin-bottom: 5px;
                      white-space: initial;
                    "
                  :style="{ float: align }"
                >
                  <div style="font-size: 12px" :style="{ color: color }">
                    <div style="padding: 5px 8px 6px" :style="{ 'background-color': background }">
                      <span style="line-height: 15.36px; line-height: 22px">
                        <template v-if="inbox.text != ''">
                          <specialtext :text="inbox.text"></specialtext>
                        </template>
                        <template v-else>-</template>
                      </span>
                    </div>
                  </div>
                  <div
                    v-if="inbox.buttons && inbox.buttons.length > 0"
                    style="
                        width: 100%;
                        border: 1px solid #eee;
                        border-bottom-right-radius: 12px;
                        border-bottom-left-radius: 12px;
                        overflow: hidden;
                      "
                    :style="{ float: align }"
                  >
                    <ul class="list-group list-group-flush" style="margin-bottom: 0px">
                      <li
                        class="list-group-item"
                        style="
                            border: none;
                            border-top: 1px solid #eee;
                            border-radius: 0px;
                            text-align: center;
                            padding: 2px 15px;
                          "
                        v-for="(button, bindex) in inbox.buttons"
                        :key="bindex"
                        :style="{
                          'border-top': bindex != 0 ? '1px solid #eee' : 'none',
                          padding: !showDeep ? '10px 0' : '2px 15px'
                        }"
                      >
                        <span style="color: #0084ff">
                          <a
                            v-if="button.type == 'web_url'"
                            :href="updateQueryString(button.url, 'from', 'livechat')"
                            target="_blank"
                            rel="noopener noreferrer"
                            >{{ button.title | truncate(20) }}
                          </a>
                          <template v-else>
                            {{ button.title | truncate(20) }}
                          </template></span
                        >
                        <div style="margin: 0; font-size: 10px" v-if="showDeep">
                          <span v-if="button.type == 'web_url'" :title="button.url">{{
                            button.url | truncate(20)
                          }}</span>
                          <span v-else-if="button.type == 'postback'" :title="button.payload">{{
                            button.payload | truncate(20)
                          }}</span>
                          <span v-else-if="button.type == 'phone_number'" :title="button.payload">{{
                            button.payload | truncate(20)
                          }}</span>
                          <span v-else>&nbsp;</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="clearfix"></div>
              </template>
              <template v-else-if="inbox.type == 'image'">
                <div
                  v-if="inbox.image_url"
                  class="message"
                  style="
                      position: relative;
                      border-radius: 12px;
                      width: 181px;
                      overflow-wrap: break-word;
                      min-height: 22px;
                      min-width: 14px;
                      line-height: 15.36px;
                      overflow: hidden;
                      margin-bottom: 5px;
                    "
                  :style="{ float: align }"
                >
                  <div style="font-size: 12px; color: black; line-height: 0">
                    <img :src="inbox.image_url" alt style="width: 100%" />
                  </div>
                </div>
              </template>
              <template v-else-if="inbox.type == 'generic'">
                <generic-viewer
                  v-model="inbox.data"
                  :size="size"
                  :ratio="inbox.ratio"
                ></generic-viewer>
              </template>
              <template v-else-if="inbox.type == 'ntn_template'">
                <ntn-viewer :ratio="inbox.ratio" :ntn_message="inbox" :size="size"></ntn-viewer>
              </template>
              <template v-else-if="inbox.type == 'welcome_message'">
                <message-viewer
                  v-if="welcomemessage"
                  v-model="welcomemessage"
                  :size="size"
                  :channel="channel"
                  :isBotTest="isBotTest"
                  @clickBtnMessage="btnClick"
                ></message-viewer>
              </template>
              <template v-else-if="inbox.type == 'video'">
                <div
                  class="message"
                  style="
                      min-height: 150px;
                      border: 1px solid #eee;
                      position: relative;
                      border-radius: 12px;
                      width: 181px;
                      overflow-wrap: break-word;
                      min-height: 22px;
                      min-width: 14px;
                      line-height: 15.36px;
                      overflow: hidden;
                    "
                  :style="{ float: align }"
                >
                  <template v-if="inbox.picture">
                    <v-img :src="inbox.picture" :aspect-ratio="16 / 9" color="grey"></v-img>
                  </template>
                  <template v-else>
                    <v-responsive :aspect-ratio="16 / 9">
                      <div style="background: #eee; height: 100%"></div>
                    </v-responsive>
                  </template>

                  <v-layout
                    fill-height
                    absolute
                    class="text-xs-center"
                    style="top: 0; bottom: 0; position: absolute; left: 0; right: 0"
                  >
                    <div
                      style="margin: auto; width: 100%"
                      :title="inbox.source"
                      :alt="inbox.source"
                    >
                      <v-btn fab small depressed color="white">
                        <v-icon large>play_circle_filled</v-icon>
                      </v-btn>
                    </div>
                  </v-layout>
                </div>
                <div class="clearfix"></div>
              </template>
              <template v-else-if="inbox.type == 'flex'">
                <div class="text-xs-left pa-2" :style="{ float: align }">
                  <LineFlexPreview :value="message" :index="index"></LineFlexPreview>
                  <!-- <vue-simple-svg
                      :filepath="'/static/img/assets/get_started/add-menu_list.svg'"
                      width="40px"
                      height="40px"
                      class="img"
                      :fill="$vuetify.theme.primary"
                    />
                    <div class="primary--text caption">Line Flex Message</div> -->
                </div>
                <div class="clearfix"></div>
              </template>
              <template
                v-else-if="['removeandaddtocart', 'addtocart', 'removetocart'].includes(inbox.type)"
              >
                <span>
                  <view-cart-summary-viewer2 :items="inbox.data"></view-cart-summary-viewer2>
                </span>
                <span></span>
              </template>
            </div>
            <div class="clearfix"></div>
          </template>
          <template v-if="message.replycomment && !showProfile">
            <i class="fas fa-check-circle primary-color"></i>
            {{ $t('Reply to comment') }}
            <div
              v-for="(comment, cindex) in message.responsecomment"
              :key="'response_comment_' + cindex"
            >
              <div
                class="message"
                v-if="comment.text != '' && comment.type == 'text'"
                style="
                    position: relative;
                    border-radius: 12px;
                    max-width: 181px;
                    overflow-wrap: break-word;
                    min-height: 22px;
                    min-width: 14px;
                    line-height: 15.36px;
                    overflow: hidden;
                    margin-bottom: 5px;
                  "
                :style="{ float: align }"
              >
                <div style="font-size: 12px" :style="{ color: color }">
                  <div style="padding: 5px 8px 6px" :style="{ 'background-color': background }">
                    <span style="line-height: 15.36px; line-height: 22px">
                      <template v-if="comment.text != ''">
                        <specialtext :text="comment.text"></specialtext>
                      </template>
                      <template v-else>-</template>
                    </span>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div
                v-if="comment.image_url"
                class="message"
                style="
                    position: relative;
                    border-radius: 12px;
                    width: 181px;
                    overflow-wrap: break-word;
                    min-height: 22px;
                    min-width: 14px;
                    line-height: 15.36px;
                    overflow: hidden;
                    margin-bottom: 5px;
                  "
                :style="{ float: align }"
              >
                <div style="font-size: 12px; color: black">
                  <img :src="comment.image_url" alt style="width: 100%" />
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </template>
          <template v-if="replies.length > 0">
            <div>
              <p class="caption" style="margin-top: 10px">{{ $t('Choice') }}</p>
              <div class="quickreply">
                <template v-if="replies.length > 0">
                  <ul class="tags">
                    <li class="tag" v-for="(reply, index) in replies" :key="'reply_' + index">
                      {{ reply }}
                    </li>
                  </ul>
                </template>
                <template v-else>-</template>
              </div>
            </div>
          </template>
          <div class="mt-1" v-if="message.hidecomment && !showProfile">
            <i class="fas fa-check-circle primary-color"></i>
            {{ $t('Hide comment') }}
          </div>
          <div class="mt-1" v-if="message.is_like_comment && !showProfile">
            <i class="fas fa-check-circle primary-color"></i>
            {{ $t('Like this comment') }}
          </div>
        </template>
        <template v-else-if="message.type == 'flex'">
          <div class="text-xs-left pa-2" :style="{ float: align }">
            <LineFlexPreview :value="message" :index="index"></LineFlexPreview>
            <!-- <vue-simple-svg
                :filepath="'/static/img/assets/get_started/add-menu_list.svg'"
                width="40px"
                height="40px"
                class="img"
                :fill="$vuetify.theme.primary"
              />
              <div class="primary--text caption">Line Flex Message</div> -->
          </div>
          <div class="clearfix"></div>
        </template>
        <template v-else-if="message.type == 'imagemap'">
          <div
            class="text-xs-center pa-2"
            style="border: 1px solid #eee; border-radius: 10px"
            :style="{ float: align }"
          >
            <img :src="message.baseUrl" style="width: 100%; max-wifth: 255px" />
          </div>
          <div class="clearfix"></div>
        </template>
        <template v-else-if="message.type == 'sticker'">
          <div
            class="text-xs-center pa-2 mb-1"
            style="border: 1px solid #eee; border-radius: 10px; width: 100%;max-width: 180px;"
            :style="{ float: align }"
          >
            <v-img
              aspect-ratio="1"
              :src="`/static/img/assets/stickers/${message.packageid}/${message.stickerid}.png`"
              :lazy-src="
                `/static/img/assets/stickers/${message.packageid}/${message.stickerid}.png`
              "
              style="width: 100%"
            >
              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
          </div>
        </template>
        <div class="clearfix"></div>
      </div>
    </div>

    <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
      >{{ $t('Copied') }}!</v-snackbar
    >
    <v-dialog v-model="showShopModal" persistent max-width="400">
      <v-card>
        <div class="text-xs-right">
          <v-spacer></v-spacer>
          <v-btn flat icon small fab @click="onCloseModel">
            <v-icon>close</v-icon>
          </v-btn>
        </div>

        <iframe
          :src="modelUrl"
          frameborder="0"
          style="overflow:hidden;width:100%"
          height="480px"
          width="100%"
        ></iframe>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import specialtext from '@/components/elements/specialtext'
import GenericViewer from '@/components/elements/GenericViewer'
import NtnViewer from '@/components/elements/NtnViewer'
import IntentGetstarted from '@/components/view/intent/IntentGetstarted'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import ViewCartSummaryViewer2 from '@/components/elements/ViewCartSummaryViewer2'
import ChannelTab from '@/components/elements/ChannelTab'
import ImageType from './ImageType'
import FileType from './FileType'
// import flex2html from '@/assets/js/flex2html.min.js'
import LineContentVideo from './LineContentVideo.vue'
import LineFlexPreview from './LineFlexPreview.vue'
import axios from 'axios'
import queryString from 'query-string'
export default {
  name: 'message-viewer',
  props: {
    errorMsg:'',
    status:'',
    message: null,
    text: String,
    isBotTest: { type: Boolean, default: false },
    quick_reply: '',
    value: {
      default: undefined
    },
    maxLength: {
      type: Number,
      default: undefined
    },
    background: {
      type: String,
      default: '#F1F0F0'
    },
    color: {
      type: String,
      default: 'black'
    },
    showDeep: {
      type: Boolean,
      default: true
    },
    size: {
      default: 'big'
    },
    showProfile: {
      default: false,
      type: Boolean
    },
    align: {
      default: 'left'
    },
    channel: {
      default: 'all'
    },
    ratioHorizontal: {
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      group: this.value,
      intent_index: 0,
      showCopy: false,
      showShopModal: false,
      modelUrl: null,
      welcome_channel: 'facebook',
      hasWCMultiChannel: false
    }
  },
  components: {
    NtnViewer,
    specialtext,
    GenericViewer,
    IntentGetstarted,
    ViewCartSummaryViewer,
    ViewCartSummaryViewer2,
    ImageType,
    FileType,
    LineContentVideo,
    LineFlexPreview,
    ChannelTab
  },
  mounted: function() {
    var vm = this
    if (vm.answers.length > 1) {
      setInterval(() => {
        if (vm.intent_index == vm.answers.length - 1) {
          vm.intent_index = 0
        } else {
          vm.intent_index++
        }
      }, 3000)
    }

    if (vm.answers.length > 0) {
      vm.answers[vm.intent_index].map(async item => {
        if (item.type === 'image') {
          if (
            vm.message &&
            vm.message.message_id &&
            vm.selectedBot &&
            vm.message.questiontype == 'image' &&
            vm.channel == 'facebook'
          ) {
            let response = await vm.getImageFAcebook()
            if (response.image_data) {
              item.image_url = response.image_data
            }
          }
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      loadingIntent: 'getLoadingIntents'
    }),
    imageProfile() {
      var http = new XMLHttpRequest()
      var image_url =
        'https://graph.facebook.com/' +
        this.selectedBot.pageid +
        '/picture?width=300&height=300&SameSite=None'
      http.open('HEAD', image_url, false)
      http.send()
      if (http.status != 404 && http.status != 400) {
        return image_url
      } else {
        return '/static/img/assets/livechat/profile.png'
      }
    },
    pageid() {
      return this.$route.name == 'allinonechat'
        ? this.$store.state.livechat.pageid
        : this.$store.getters.selectedBot.pageid
    },
    welcomemessage() {
      let { messages, multichannel } = this.$store.getters.welcomeMessage2(
        this.channel == 'all' ? this.welcome_channel : this.channel
      )
      this.hasWCMultiChannel = multichannel
      return messages
    },
    replies: function() {
      var vm = this
      if (vm.quick_reply !== '' && vm.quick_reply != null) {
        var replies = vm.quick_reply.split(',')
        return replies
      } else {
        return []
      }
    },
    answers: function() {
      var vm = this
      if (vm.group == null) {
        return []
      }
      var messagelist = []
      $.each(vm.value, function(index, group) {
        var newGroup = []
        $.each(group, function(mindex, message) {
          if (
            (message.type === 'text' && message.text !== '') ||
            (message.type === 'button' &&
              message.buttons &&
              (message.buttons.length > 0 || message.text !== '')) ||
            (message.type === 'image' && message.image_url !== '' && message.image_url !== null) ||
            (message.type === 'file' && message.file_url !== '' && message.file_url !== null) ||
            message.type === 'welcome_message' ||
            (message.type === 'flex' && message.contents !== '') ||
            (message.type === 'payment' && message.detail !== '') ||
            (message.type === 'pay_solutions_link' && message.detail !== '') ||
            (message.type === 'meta_pay' && message.detail !== '') ||
            (['removeandaddtocart', 'addtocart', 'removetocart'].includes(message.type) &&
              message.detail !== '')
          ) {
            const _message = Object.assign({}, message)
            if (vm.maxLength && _message.type === 'text' && _message.text.length > vm.maxLength) {
              _message.text = _message.text.substring(0, vm.maxLength) + '...'
            }
            
            newGroup.push(_message)
          } else if (message.type === 'generic') {
            var generics = []
            $.each(message.data, function(gindex, g) {
              if (
                g.title !== '' ||
                g.subtitle !== '' ||
                g.buttons.length > 0 ||
                (g.image_url !== '' && g.image_url != null) ||
                (g.file_url !== '' && g.file_url != null) ||
                (typeof g.productid != 'undefined' && g.productid != null)
              ) {
                generics.push(g)
              }
            })
            if (generics.length > 0) {
              newGroup.push({
                type: 'generic',
                data: generics,
                ratio: vm.ratioHorizontal || message.ratio == 'horizontal' ? 'horizontal' : 'square'
              })
            }
          } else if (message.type === 'ntn_template') {
            newGroup.push({
              type: 'ntn_template',
              data: message,
              ratio: message.ratio == 'horizontal' ? 'horizontal' : 'square'
            })
          } else if (message.type === 'responsepost') {
            if (vm.showProfile) {
              if (
                message.replyinbox === true &&
                message.responseinbox[0].text !== '' &&
                message.responseinbox[0].text !== null
              ) {
                newGroup.push(message)
              }
            } else {
              if (
                (message.replyinbox === true &&
                  message.responseinbox[0].text !== '' &&
                  message.responseinbox[0].text !== null) ||
                (message.replycomment === true &&
                  message.responsecomment[0].text !== '' &&
                  message.responsecomment[0].text !== null) ||
                message.hidecomment === true ||
                message.is_like_comment === true
              ) {
                newGroup.push(message)
              }
            }
          } else if (['video', 'audio', 'imagemap', 'sticker'].includes(message.type)) {
            newGroup.push(message)
          }
        })
        if (newGroup.length > 0) {
          messagelist.push(newGroup)
        }
      })
      if (messagelist.length === 0) {
        messagelist = [[]]
      }
      vm.group = messagelist

      return vm.group
      // try {
      // var group_messages = vm.group.split('||')
      // $.each(group_messages,function(index, messages){
      //     var messages = messages.split('#nl')
      //     var newMessages = []
      //     $.each(messages, function(inedx, message){
      //         if (vm.isURL(message)) {
      //             newMessages.push(
      //                 {
      //                     type: 'image',
      //                     value: message
      //                 }
      //             )
      //         } else if (!isNaN(message)) {
      //             newMessages.push({
      //                 type: 'text',
      //                 value: {
      //                     text: message,
      //                     buttons: []
      //                 }
      //             })
      //         } else if(vm.isJsonParseable(message)) {
      //             newMessages.push(
      //                 {
      //                     type: 'text',
      //                     value: JSON.parse(message)
      //                 }
      //             )
      //         } else {
      //             newMessages.push(
      //                 {
      //                     type: 'text',
      //                     value: {
      //                         text: message,
      //                         buttons: []
      //                     }
      //                 }
      //             )
      //         }
      //     })
      //     group.push(newMessages)
      // })
      // } catch (error) {
      //     // console.log(vm.group)
      // }
    }
  },
  methods: {
    async getImageFAcebook() {
      const vm = this
      try {
        let response = await axios.get(
          `https://graph.facebook.com/v14.0/${vm.message.message_id}/attachments?access_token=${vm.selectedBot.page_access_token}`
        )
        if (response && response.data) {
          return response.data.data
        }
      } catch (error) {
        console.log(error)
      }
    },
    changeWelcomeChannelTab(val) {
      this.welcome_channel = val
    },
    onCloseModel() {
      this.modelUrl = null
      this.showShopModal = false
    },
    openShopModel(url) {
      this.modelUrl = null
      this.modelUrl = url
      this.$nextTick(() => {
        this.showShopModal = true
      })
    },
    btnClick(button) {
      this.$emit('clickBtnMessage', button)
    },
    updateQueryString(uri, key, value) {
      try {
        uri = uri.trim()
      } catch (error) {}
      let qs = queryString.parseUrl(uri)
      qs.query[key] = value
      return queryString.stringifyUrl(qs)
    },
    onCopy: function() {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    },
    onCopyError: function() {}
  },
  watch: {
    value: function(newVal, oldVal) {
      // this.group = this.value
    }
  },
  filters: {
    splitimg: function(value) {
      return value.split(';;')
    }
  }
}
</script>

<style scoped>
.message {
  word-break: break-word;
}
.alert-icon {
  margin-left: auto;
  margin-right: 0px;
  color: crimson;
}
.warning-icon {
  margin-left: auto;
  margin-right: 0px;
  color: #ffc107;
}
.tooltip-error.margin-icon{
  position: absolute;
  z-index: 1;
  top: 8px;
  left: -22px;
}
.tooltip-error.warning-icon{
  position: absolute;
  z-index: 1;
  top: 8px;
  right: -22px;
}
</style>

<style lang="scss">
// @import '@/assets/css/flex2html.scss';
</style>



// WEBPACK FOOTER //
// src/components/elements/MessageViewer.vue